import axiosInstance from "../../axiosInstance";

// const base = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
// const BASE_URL = `${base}/contact-history`;

const BASE_URL = "/crm/contact-history";

export const getAllContactHistories = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}`, { params });
  return res.data;
};

export const getContactHistoryStats = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/stats/summary`, { params });
  return res.data;
};

export const getContactHistoryById = async (id) => {
  const res = await axiosInstance.get(`${BASE_URL}/${id}`);
  return res.data;
};

export const getContactHistoriesByCustomer = async (customerId, params = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/customer/${customerId}/logs`, { params });
  return res.data;
};

export const createContactHistory = async (payload) => {
  const res = await axiosInstance.post(`${BASE_URL}`, payload);
  return res.data;
};

export const updateContactHistory = async (id, payload) => {
  const res = await axiosInstance.put(`${BASE_URL}/${id}`, payload);
  return res.data;
};

export const progressUpdateContactHistory = async (id, payload) => {
  const res = await axiosInstance.post(`${BASE_URL}/${id}/progress-update`, payload);
  return res.data;
};

export const deleteContactHistory = async (id) => {
  const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return res.data;
};
